const getters = {
  isLogin: state => state.home.isLogin,
  clientData: state => state.user.clientData,
  userInfo: state => state.user.userInfo,
  type: state => state.home.type,
  plantInfo: state => state.home.plantInfo,
  time: state => state.home.time,
  personInfo: state => state.user.personInfo
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js